import {
    AMOUNT_ACTION,
    BACK_SCREEN,
    CARD_NUMBER_ACTION,
    COMMENT_ACTION,
    IN_CURRENCY_ACTION,
    IN_CURRENCY_SHOW_ACTION,
    MIN_MAX_HALF_ACTION,
    NEXT_SCREEN,
    OUT_CURRENCY_ACTION,
    OUT_CURRENCY_SHOW_ACTION,
    OUT_DESTINATION_ACTION,
    OUT_DESTINATION_SHOW_ACTION,
    OUT_DESTINATION_TIME_ACTION,
    PROVIDER_ACTION,
    SWAP_CURRENCY_ACTION,
    ORDER_CREATED_ACTION,
    NOT_ACTIVE_IN_CURRENCY_ACTION,
    NOT_ACTIVE_OUT_CURRENCY_ACTION,
    NEW_OUT_DESTINATION_ACTION,
    VALIDATION_OUT_DESTINATION_ACTION,
    SEARCH_MODAL_IN_ACTION,
    SEARCH_MODAL_OUT_ACTION,
    CURRENCY_ARRAY_ACTION,
    MODAL_ERROR_ACTION,
    LOADER_ACTION,
    FAIL_PROVIDERS,
    IN_CURRENCY_COIN,
    OUT_CURRENCY_COIN,
    CLOSE_MODAL_ACTION,
    RATE_PROVIDER_ACTION,
    WALLET_NAME_ACTION,
    LIMITS_ARRAY_ACTION,
    BACK_FIRST_SCREEN_ACTION,
    ADVANCED_CLOSE_ACTION,
    DESTINATION_TAG_ACTION,
    CREATED_ORDER_ERROR,
    EXPIRATED_RATE,
    ORDER_ACTION,
    LOADING_ACTION,
    MODAL_SERVER,
    MIN_MAX_ACTION,
    COUNTED_FEES,
    CHECKED_ALMOST_ALL,
    POST_MESSAGE_ERROR,
    BALANCE_HODL_MSG
} from '../type'

export function inCurrencyAction(inCurrency, minMaxLimits, inDestination) {
    return {
        type: IN_CURRENCY_ACTION,
        inCurrency,
        minMaxLimits,
        inDestination
    }
}

export function notActiveInCurrencyAction(inCurrency, inDestination) {
    return {
        type: NOT_ACTIVE_IN_CURRENCY_ACTION,
        inCurrency,
        inDestination
    }
}

export function outCurrencyAction(outCurrency, minMaxLimits, outDestination, walletName) {
    return {
        type: OUT_CURRENCY_ACTION,
        outCurrency,
        minMaxLimits,
        outDestination,
        walletName
    }
}

export function notActiveOutCurrencyAction(outCurrency, outDestination, walletName) {
    return {
        type: NOT_ACTIVE_OUT_CURRENCY_ACTION,
        outCurrency,
        outDestination,
        walletName
    }
}

export function amountAction(amount, equivalent = null, timerId = null, providersArray = [], amountValid = false, amountHaveValid = false, loading = false, side = null, equivalentTime=null) {
    return {
        type: AMOUNT_ACTION,
        amount,
        equivalent,
        timerId,
        providersArray,
        amountValid,
        amountHaveValid,
        loading,
        side,
        equivalentTime
    }
}

export function nextAction(screen) {
    return {
        type: NEXT_SCREEN,
        screen
    }
}

export function backAction() {
    return {
        type: BACK_SCREEN,
    }
}

export function outDestinationAction(outDestination, walletName) {
    return {
        type: OUT_DESTINATION_ACTION,
        outDestination,
        walletName,
    }
}

export function cardNumberAction(cardNumber) {
    return {
        type: CARD_NUMBER_ACTION,
        cardNumber
    }
}

export function commentAction(comment) {
    return {
        type: COMMENT_ACTION,
        comment
    }
}

export function providerAction(provider) {
    return {
        type: PROVIDER_ACTION,
        provider
    }
}

export function minMaxHalfAction(minMaxHalf, minMaxLimits) {
    return {
        type: MIN_MAX_HALF_ACTION,
        minMaxHalf,
        minMaxLimits
    }
}

export function inCurrencyShowAction() {
    return {
        type: IN_CURRENCY_SHOW_ACTION,
    }
}

export function outCurrencyShowAction() {
    return {
        type: OUT_CURRENCY_SHOW_ACTION,
    }
}

export function outDestinationShowAction() {
    return {
        type: OUT_DESTINATION_SHOW_ACTION,
    }
}

export function outDestinationTimeAction(outDestination) {
    return {
        type: OUT_DESTINATION_TIME_ACTION,
        outDestination
    }
}

export function orderCreatedAction() {
    return {
        type: ORDER_CREATED_ACTION,
    }
}

export function swapCurrencyAction(minMaxLimits, outDestination, walletName, inDestination) {
    return {
        type: SWAP_CURRENCY_ACTION,
        minMaxLimits,
        outDestination,
        walletName,
        inDestination
    }
}

export function newOutDestinationAction() {
    return {
        type: NEW_OUT_DESTINATION_ACTION
    }
}

export function validationOutDestinationAction(destinationValid, destinationError=false) {
    return {
        type: VALIDATION_OUT_DESTINATION_ACTION,
        destinationValid,
        destinationError
    }
}

export function searchInputModalInAction(searchValue) {
    return {
        type: SEARCH_MODAL_IN_ACTION,
        searchValue,
    }
}

export function searchInputModalOutAction(searchValue) {
    return {
        type: SEARCH_MODAL_OUT_ACTION,
        searchValue,
    }
}

export function currencyArrayAction(currencyArray, currencyNotActiveArray) {
    return {
        type: CURRENCY_ARRAY_ACTION,
        currencyArray,
        currencyNotActiveArray,
    }
}

export function modalErrorAction(modalError, textError=null) {
    return {
        type: MODAL_ERROR_ACTION,
        modalError,
        textError
    }
}

export function loaderAction(loader) {
    return {
        type: LOADER_ACTION,
        loader,
    }
}

export function providersStatusAction(failProviders, rateProvider = null) {
    return {
        type: FAIL_PROVIDERS,
        failProviders,
        rateProvider
    }
}

export function inCurrencyCoinAction(inCurrencyActive, inCurrencyNotActive) {
    return {
        type: IN_CURRENCY_COIN,
        inCurrencyActive,
        inCurrencyNotActive
    }
}

export function outCurrencyCoinAction(outCurrencyActive, outCurrencyNotActive) {
    return {
        type: OUT_CURRENCY_COIN,
        outCurrencyActive,
        outCurrencyNotActive
    }
}

export function closeModalAction() {
    return {
        type: CLOSE_MODAL_ACTION
    }
}

export function rateProviderAction(rateProvider, minMaxLimits) {
    return {
        type: RATE_PROVIDER_ACTION,
        rateProvider,
        minMaxLimits
    }
}

export function walletNameAction(outDestination, walletName) {
    return {
        type: WALLET_NAME_ACTION,
        outDestination,
        walletName
    }
}

export function limitsArrayAction(minMaxLimits, limitsTimerId) {
    return {
        type: LIMITS_ARRAY_ACTION,
        minMaxLimits,
        limitsTimerId
    }
}

export function backFirstScreenAction() {
    return {
        type: BACK_FIRST_SCREEN_ACTION,
    }
}

export function advancedCloseAction(newOutDestination) {
    return {
        type: ADVANCED_CLOSE_ACTION,
        newOutDestination
    }
}

export function destinationTagAction(destinationTag) {
    return {
        type: DESTINATION_TAG_ACTION,
        destinationTag
    }
}

export function createdOrderErrorAction(createdOrderError) {
    return {
        type: CREATED_ORDER_ERROR,
        createdOrderError
    }
}

export function expiratedRateAction(expiratedRate) {
    return {
        type: EXPIRATED_RATE,
        expiratedRate
    }
}

export function orderAction (order) {
    return{
        type: ORDER_ACTION,
        order
    }
}

export function loadingAction(loading) {
    return {
        type: LOADING_ACTION,
        loading
    }
}

export function modalServerAction(modalServer, textError=null) {
    return {
        type: MODAL_SERVER,
        modalServer,
        textError
    }
}

export function minMaxLimitsAction (minMaxLimits, limitLabel) {
    return {
        type: MIN_MAX_ACTION,
        minMaxLimits,
        limitLabel
    }
}

export function allFundsAction (useAllFunds, loadAmount) {
    return {
        type: COUNTED_FEES,
        useAllFunds,
        loadAmount,
    }
}

export function checkedAlmostAllAction (checkedAlmostAll, originalData={}){
    return {
        type: CHECKED_ALMOST_ALL,
        checkedAlmostAll,
        originalData
    }
}

export function postMessageErrorAction (postMessageError) {
    return {
        type: POST_MESSAGE_ERROR,
        postMessageError
    }
}

export function balanceHodlMsgAction(balanceHodlMsg) {
    return {
        type: BALANCE_HODL_MSG,
        balanceHodlMsg
    }
}